export enum EErrorCode {
    Required = 'required',
    InvalidType = 'invalidType',
    Min = 'min',
    Max = 'max',
    Enum = 'enum',
    Range = 'range',
    MultipleOf = 'multipleOf',
    Format = 'format',
}

export interface IReactHookFormErrorContent {
    type: string;
    types: Record<string, unknown>[];
}

export type IReactHookFormErrors = Record<string, IReactHookFormErrorContent>;
